import { type ApolloError } from "@apollo/client";
import ErrorScreen from "@components/error-pages/error-screen";
import { GenericExternalLink } from "@components/generic-external-link";
import { type FetchSpreadsheets } from "@north-beam/nb-client-side";

export const SpendSheet = ({
  queryResult: { data, loading, error },
  placeholder,
}: {
  queryResult: {
    data?: FetchSpreadsheets;
    loading: boolean;
    error?: ApolloError;
  };
  placeholder: React.ReactNode;
}) => {
  if (loading) {
    return <>{placeholder}</>;
  }

  if (error) {
    return <ErrorScreen />;
  }

  const { url: customSpendSheetLink } = data?.me.customSpendSheets?.[0] || {};
  if (!customSpendSheetLink) {
    console.warn("no data");
    return <>{placeholder}</>;
  }

  return (
    <>
      <div className="row col-8">
        <div>
          You can also{" "}
          <GenericExternalLink href={customSpendSheetLink}>
            open in a new tab.
          </GenericExternalLink>
        </div>
      </div>
      <div className="w-full row">
        <div className="py-1 mb-5 col-12">
          <iframe
            src={customSpendSheetLink}
            title="Spreadsheet"
            width="100%"
            height="668.49"
            allowFullScreen
            className="border rounded-lg"
          />
        </div>
      </div>
    </>
  );
};
